var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h3",
      { staticClass: "text-lg leading-6 font-medium text-gray-900 mt-5" },
      [_vm._v(" Campaign Stats ")]
    ),
    _c("div", { staticClass: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3" }, [
      _c("div", { staticClass: "bg-white overflow-hidden shadow rounded-lg" }, [
        _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
          _c("dl", [
            _c(
              "dt",
              {
                staticClass:
                  "text-sm leading-5 font-medium text-gray-500 truncate"
              },
              [_vm._v(" Total Subscribers ")]
            ),
            _c(
              "dd",
              {
                staticClass:
                  "mt-1 text-3xl leading-9 font-semibold text-gray-900"
              },
              [_vm._v(" " + _vm._s(_vm.report.totalSubscribers) + " ")]
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "bg-white overflow-hidden shadow rounded-lg" }, [
        _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
          _c("dl", [
            _c(
              "dt",
              {
                staticClass:
                  "text-sm leading-5 font-medium text-gray-500 truncate"
              },
              [_vm._v(" Sent ")]
            ),
            _c(
              "dd",
              {
                staticClass:
                  "mt-1 text-3xl leading-9 font-semibold text-gray-900"
              },
              [_vm._v(" " + _vm._s(_vm.report.sentSubscribers) + " ")]
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "bg-white overflow-hidden shadow rounded-lg" }, [
        _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
          _c("dl", [
            _c(
              "dt",
              {
                staticClass:
                  "text-sm leading-5 font-medium text-gray-500 truncate"
              },
              [_vm._v(" Failed ")]
            ),
            _c(
              "dd",
              {
                staticClass:
                  "mt-1 text-3xl leading-9 font-semibold text-gray-900"
              },
              [_vm._v(" " + _vm._s(_vm.report.failedSubscribers) + " ")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }